/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import { Collapse, Badge, Table } from 'reactstrap';
import Alert from 'react-s-alert';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// service imports
import ProviderService from '../../services/ProviderService';
import GeneralService from '../../services/GeneralService';

// local imports
import UserNotApproved from './UserNotApproved';
import ErrorBoundary from '../general/ErrorBoundary';
import ProviderNavbar from './ProviderNavbar';

const ClientFormResponse = props => {

    const [isLoading, setIsLoading] = useState(true);
    const [formList, setFormList] = useState([]);
    const [selectedForm, setSelectedForm] = useState(-1);
    const [expandAll, setExpandAll] = useState(false);
    const [userData, setUserData] = useState({ id: "", name: "", profileImage: "" });

    // contexts
    const { theme, colors } = useContext(ThemeContext);
    const { userApprovalStatus } = useContext(AuthContext);

    // useEffect
    useEffect(() => {
        if (props.location.state) {
            setIsLoading(true);
            setUserData({ id: props.location.state.id, name: props.location.state.name, profileImage: props.location.state.profileImage });
            ProviderService.getClientFormResponse(props.location.state.id)
                .then(data => {
                    try {
                        setFormList(data.forms);
                        setIsLoading(false);
                    } catch (err) {
                        Alert.error("Some error occured, please try again later or report support team.", {
                            position: 'top-right',
                            effect: 'slide'
                        });
                        GeneralService.logError('at Provider ClientFormResponse useEffect', 'Error in try catch block', err.stack);
                    }
                });
        } else {
            props.history.push('/counsellor/clients');
        }
    }, []);

    const toggle = (index) => {
        try {
            const tempMainArray = [...formList];
            tempMainArray[selectedForm].response[index].isOpen = !tempMainArray[selectedForm].response[index].isOpen;
            setFormList(tempMainArray);
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Provider FAQ toggle', 'Error in try catch block', err.stack);
        }
    };

    const handleExpanAll = () => {
        const tempMainArray = [...formList];
        if (expandAll) {
            tempMainArray[selectedForm].response.map(item => item.isOpen = false);
        } else {
            tempMainArray[selectedForm].response.map(item => item.isOpen = true);
        }
        setExpandAll(!expandAll);
        setFormList(tempMainArray);
    }

    return (
        <div>
            <ErrorBoundary errorAt="At Provider ClientFormResponse ProviderNavbar">
                <ProviderNavbar history={props.history} />
            </ErrorBoundary>
            {
                userApprovalStatus ?
                    <div className="p-3">
                        {
                            selectedForm === -1 ?
                                <div>
                                    <h4>Select a form to view response</h4>
                                    <div className="p-3 mt-3" style={theme.card}>
                                        <div className="row px-3">
                                            <div className="text-center" style={{ width: "45px", height: "45px" }}>
                                                <img className="w-100 h-100" src={userData.profileImage} alt="Profile picture" style={{ borderRadius: "100%", border: "solid 3px #C4C4C4" }} />
                                            </div>
                                            <div className="mx-3 my-auto" style={{ fontSize: "1.4rem", fontWeight: "600" }}>{userData.name}</div>
                                        </div>
                                        <hr />
                                        {
                                            isLoading ?
                                                <h4>Loading...</h4>
                                                :
                                                formList.length === 0 ?
                                                    <h4>No response found</h4>
                                                    :
                                                    formList.map((item, index) => (
                                                        <ErrorBoundary errorAt={`At ClientFormResponse FormList${index}`}>
                                                            <div className="px-3 py-2 my-3" style={Object.assign({ cursor: "pointer" }, theme.card)}>
                                                                <h5 key={index} className="mb-0" onClick={() => { setSelectedForm(index); }}>{`${index + 1}. ${item.form}`}</h5>
                                                            </div>
                                                        </ErrorBoundary>
                                                    ))
                                        }
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className="d-flex my-4">
                                        <h3 style={{ marginRight: "15px", cursor: "pointer" }} onClick={() => setSelectedForm(-1)}><i className="fas fa-arrow-left"></i></h3>
                                        <h3>{formList[selectedForm].form}</h3>
                                        <h5 className="ml-auto" style={{ cursor: "pointer" }} onClick={handleExpanAll}>{expandAll ? "Collapse all" : "Expand all"}</h5>
                                    </div>
                                    {
                                        formList[selectedForm].response.map((item, index) => (
                                            <div key={index} className="p-3 my-3" style={theme.card}>
                                                <ErrorBoundary errorAt={`At ClientFormResponse FormResponse${index}`}>
                                                    <div className="d-flex" style={{ cursor: "pointer" }} onClick={() => toggle(index)}>
                                                        <Badge style={{ backgroundColor: colors.primary, marginRight: "15px", height: "fit-content" }}>{index + 1}</Badge>
                                                        <span style={theme.headingBold}>{item.question}</span>
                                                        <span className="ml-auto" style={{ marginLeft: "15px" }}>
                                                            {
                                                                formList[selectedForm].response[index].isOpen
                                                                    ? <i className="fas fa-angle-up"></i>
                                                                    : <i className="fas fa-angle-down"></i>
                                                            }
                                                        </span>
                                                    </div>

                                                    <Collapse isOpen={formList[selectedForm].response[index].isOpen}>
                                                        <hr />
                                                        <Table className="mb-0" borderless>
                                                            <tbody>
                                                                {
                                                                    item.answers.map((item2, index) => (
                                                                        <tr key={index} style={item.userResponse.includes(item2) ? { fontWeight: "bold" } : {}}>
                                                                            <td style={{ padding: "0 0 0 8px" }}><span>{item2}{item.userResponse.includes(item2) ? <i style={{ color: "#009a34" }} className="fas fa-check ml-2"></i> : null}</span></td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Collapse>
                                                </ErrorBoundary>
                                            </div>
                                        ))
                                    }
                                </div>
                        }
                    </div>
                    :
                    <UserNotApproved />
            }
        </div>
    )

}

export default ClientFormResponse;